export { default } from './TimelineItem';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/lab/esm/TimelineItem/index.js
// module id = 385
// module chunks = 0